import React from 'react';
import Frame from "../common/Frame";
import Footer from "../common/Footer";
import {useTranslation} from "react-i18next";
import {appdata} from "../../logic_tmp/appdata/AppData";

export function PastEventPage() {
    const { t } = useTranslation();
    
    return (
        <div>
            <Frame>
                <h2 className="offer-pay__title">
                    {t("ThisEventHasPassed")}
                </h2>
                <Footer></Footer>
            </Frame>
        </div>
    );
} 